import { render, staticRenderFns } from "./FileFoldersList.vue?vue&type=template&id=0f8251ea&scoped=true&"
import script from "./FileFoldersList.vue?vue&type=script&lang=js&"
export * from "./FileFoldersList.vue?vue&type=script&lang=js&"
import style0 from "./FileFoldersList.vue?vue&type=style&index=0&id=0f8251ea&lang=scss&scoped=true&"
import style1 from "./FileFoldersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8251ea",
  null
  
)

export default component.exports